/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import {Box, Typography, Grid, Container,Button } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import SelectionPanel from '../SelectionPanel';
import CustomSignUp from "../CustomSignUp";
import ContactForm from "../ContactForm";
import FeaturesSection from "../FeaturesSection";
import CtaSection from "../CtaSection";
import HomeFooter from "../HomeFooter";

// Material Dashboard 2 React example components
import HomeNavbar from "examples/Navbars/HomeNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";
import { position } from "stylis";

function HomeLayout({ image, children }) {
  return (
    <>
    <PageLayout background="#ffff" >
       <HomeNavbar
        action={{
          type: "external",
          route: "https://creative-tim.com/product/material-dashboard-react",
          label: "free download",
          color: "dark",
        }}
      />
      
      <MDBox px={1} width="100%" height="100%" sx={{paddingTop:13}}>
        <Grid container height="100%">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {children}
          </Grid>
        </Grid>

      </MDBox>

       {/* <CustomSignUp/> */}

        <FeaturesSection />

        <SelectionPanel />

        <CtaSection />

        <ContactForm />

        <HomeFooter />  

    </PageLayout>
    </>
  );
}

// Typechecking props for the BasicLayout
HomeLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default HomeLayout;
